import { FormSchema } from '@/forms/types/schema';
import { ImportHexnodeDeviceFieldValues } from './field-values';

export const importHexnodeDeviceFormSchema: FormSchema<ImportHexnodeDeviceFieldValues> =
  {
    tabletId: {
      type: 'text',
      label: 'Tablet ID',
      placeholder: 'Enter HexNode tablet ID',
      validation: { required: true },
    },
  };
